module.exports = __webpack_public_path__ + "static/media/Lunch.54cae169.pdf";